module.exports = __webpack_public_path__ + "static/media/brand3.24282007.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/brand3.png
// module id = 532
// module chunks = 0